import React from "react";
import CEMEDIDashboardView from "../CEMEDIDashboardView";

function RootDashboardView() {
  return <CEMEDIDashboardView />;
}

export default RootDashboardView;
